import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Tooltip } from "react-tooltip";
interface DropVoteProgressingProps {
  readonly current: number | null | undefined;
  readonly projected: number | null | undefined;
  readonly subtle?: boolean;
}
export default function DropVoteProgressing(t0) {
  const $ = _c(22);
  const {
    current,
    projected,
    subtle: t1
  } = t0;
  const subtle = t1 === undefined ? false : t1;
  if (typeof current !== "number" || typeof projected !== "number") {
    return null;
  }
  const isProgressing = current !== projected;
  if (!isProgressing) {
    return null;
  }
  const isPositiveProgressing = current < projected;
  let color;
  let arrowColor;
  if (subtle) {
    color = isPositiveProgressing ? "tw-text-iron-400 tw-font-mono" : "tw-text-iron-600 tw-font-mono";
    arrowColor = "tw-text-iron-600";
  } else {
    color = isPositiveProgressing ? "tw-text-emerald-400 tw-bg-emerald-900/40 tw-px-1.5 tw-py-0.5 tw-rounded-md" : "tw-text-rose-400 tw-bg-rose-900/40 tw-px-1.5 tw-py-0.5 tw-rounded-md";
    arrowColor = isPositiveProgressing ? "tw-text-emerald-400" : "tw-text-rose-400";
  }
  const t2 = `tw-flex tw-items-center tw-gap-2 ${subtle ? "" : "tw-ml-0.5"}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      animationDuration: "2s"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = `drop-vote-progress-${current}-${projected}`;
  const t5 = `tw-flex-shrink-0 tw-size-2.5 ${arrowColor}`;
  let t6;
  if ($[1] !== t5) {
    t6 = <FontAwesomeIcon icon={faArrowRight} className={t5} />;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const t7 = `tw-text-xs tw-font-medium ${color}`;
  let t8;
  if ($[3] !== projected) {
    t8 = formatNumberWithCommas(projected);
    $[3] = projected;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t7 || $[6] !== t8) {
    t9 = <span className={t7}>{t8}</span>;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t6 || $[11] !== t9) {
    t10 = <span className={t2} style={t3} data-tooltip-id={t4}>{t6}{t9}</span>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t6;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = `drop-vote-progress-${current}-${projected}`;
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    };
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== projected) {
    t13 = formatNumberWithCommas(projected);
    $[14] = projected;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t11 || $[17] !== t13) {
    t14 = <Tooltip id={t11} place="top" offset={8} opacity={1} style={t12}>Projected vote count at decision time:{" "}{t13}</Tooltip>;
    $[16] = t11;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t10 || $[20] !== t14) {
    t15 = <>{t10}{t14}</>;
    $[19] = t10;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
}